export const SIDE_MENU_ACTION_BAR_VERTICAL_HEIGHT = 108;
export const SIDE_MENU_ACTION_BAR_HORIZONTAL_HEIGHT = 66;
